import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { TaxabilityBadgeProps } from "./TaxabilityBadge.types"

const icon = faIcon({ name: "coins", style: "regular" })

export default function TaxabilityBadge(props: TaxabilityBadgeProps) {
    const { isTaxable, size = "md" } = props

    return (
        <Badge size={size} variant="icon" icon={icon}>
            {isTaxable ? "Taxable" : "Non-Taxable"}
        </Badge>
    )
}
